// API / WebSocket 配置

function getWebSocketUrl() {
  const explicit = process.env.VUE_APP_WS_URL;
  if (explicit != null && String(explicit).trim() !== '') {
    return String(explicit).trim();
  }

  if (typeof window === 'undefined') {
    return 'ws://127.0.0.1:2346';
  }

  const wssUrl = process.env.VUE_APP_WS_WSS_URL;
  const wsUrl = process.env.VUE_APP_WS_WS_URL;
  const secure = window.location.protocol === 'https:';

  if (secure) {
    if (wssUrl != null && String(wssUrl).trim() !== '') {
      return String(wssUrl).trim();
    }
  } else if (wsUrl != null && String(wsUrl).trim() !== '') {
    return String(wsUrl).trim();
  }

  let path = process.env.VUE_APP_WS_PATH || '/ws';
  path = path.startsWith('/') ? path : `/${path}`;
  const proto = secure ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${path}`;
}

export default {
  getWebSocketUrl
};
